// Matchmaking system constants

// Matchmaking configuration
export const matchmakingShortBaseTimer = 10000 // Base time after reaching minimum players (10s)
export const matchmakingForceTimer = 30000 // Maximum time from first reaching minPlayers (30s)
export const matchmakingCountdownTimer = 5000 // Final countdown before starting (5s)
export const matchmakingPenaltyTimer = 5000 // Shortened time for unstable lobbies (5s)
export const matchmakingInstabilityThreshold = 3 // After this many rollbacks, penalty mode activates
export const matchmakingOptimalPlayers = 4 // Optimal number of players for best experience

// Game duration settings
export const defaultGameDuration = 300_000
export const gameDuration = new Map(
  [2, 3, 4, 5, 6, 7].map((n) => [n, defaultGameDuration + (n - 2) * 90_000])
)

// Turn duration settings
export const defaultTurnDuration = 20000
export const turnDuration = new Map([
  [2, defaultTurnDuration],
  [3, defaultTurnDuration],
  [4, defaultTurnDuration],
  [5, defaultTurnDuration],
  [6, defaultTurnDuration],
  [7, defaultTurnDuration],
])
